import Base64 from "./base64.js"
import {systemFn,runChannel} from "./common.js"
import store from '@/store'
var Api = (function () {

    var apihost = window.location.protocol + "//api.sxjy.yishunjing.top"
    if (window.location.hostname == "localhost" || window.location.hostname == "192.168.56.1") {
        // v5 测试服务器
        apihost = "https://api.anchor.yishunjing.top"
        // apihost =  "https://api.sxjy.yishunjing.top"

    }
    if (window.location.hostname == "h5.anchor.yishunjing.top") {
        // v5 测试服务器
        apihost = "https://api.anchor.yishunjing.top"
        // apihost =  "https://api.sxjy.yishunjing.top"

    }
    // 游戏盒子所有渠道
    var boxChannelList = ['dawbox', 'dawbox-android', 'dawbox-nc-android', 'dawbox-lot-android', 'dawbox-nc-android2'];
    // 获取当前渠道 1:安卓 2:ios 3:网页 5:网页
    var system = systemFn();
    // 配置信息
    var config;
    // ios 环境下设置配置信息
    if (system === 2) {
        window.appIosCallback = function (data) {
            var iosInfo = JSON.parse(Base64.decode(data));
            // config={
            //     token : iosInfo.token,
            //     appid : iosInfo.getAppId,
            //     appkey : iosInfo.getAppKey,
            //     channel : iosInfo.getChannel,
            //     maker : iosInfo.getMaker,
            //     mobile_model : iosInfo.getMobileModel,
            //     machine_code : iosInfo.getMachineCode,
            //     system_version : iosInfo.getVersionName,
            //     getAdLinkUrl : iosInfo.getAdLinkUrl,
            //     getAdImageUrl : iosInfo.getAdImageUrl,
            //     isDisplayAd : iosInfo.isDisplayAd,
            //     isRegisterEnabled : iosInfo.isRegisterEnabled,
            //     isNameAuthEnabled : iosInfo.isNameAuthEnabled,
            //     isPlatformMoneyEnabled : iosInfo.isPlatformMoneyEnabled,
            //     isBindMobileEnabled : iosInfo.isBindMobileEnabled,
            //     getDiscount : iosInfo.getDiscount,
            //     host: apihost,
            //     key: '14e1b600b1fd579f47433b88e8d85291',
            //     system: system,
            // }
            Api.config.token = iosInfo.token;
            Api.config.appid = iosInfo.getAppId;
            Api.config.appkey = iosInfo.getAppKey;
            Api.config.channel = iosInfo.getChannel;
            Api.config.maker = iosInfo.getMaker;
            Api.config.mobile_model = iosInfo.getMobileModel;
            Api.config.machine_code = iosInfo.getMachineCode;
            Api.config.system_version = iosInfo.getVersionName;
            Api.config.getAdLinkUrl = iosInfo.getAdLinkUrl;
            Api.config.getAdImageUrl = iosInfo.getAdImageUrl;
            Api.config.isDisplayAd = iosInfo.isDisplayAd;
            Api.config.isRegisterEnabled = iosInfo.isRegisterEnabled;
            Api.config.isNameAuthEnabled = iosInfo.isNameAuthEnabled;
            Api.config.isPlatformMoneyEnabled = iosInfo.isPlatformMoneyEnabled;
            Api.config.isBindMobileEnabled = iosInfo.isBindMobileEnabled;
            Api.config.getDiscount = iosInfo.getDiscount;
        };
        config = {
            host: apihost,
            key: '14e1b600b1fd579f47433b88e8d85291',
            system: system,
        }
        try {
            window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'getAppInfo' });

        } catch (error) {

        }

    } else if (system === 1) { // 安卓 环境下设置配置信息
        config = {
            host: apihost,
            key: '14e1b600b1fd579f47433b88e8d85291',
            system: system,
            token: (function () {
                if (system === 1) {
                    return window.Android.getUsertoken();

                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            appid: (function () {
                if (system === 1) {
                    return window.Android.getAppId();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            appkey: (function () {
                if (system === 1) {
                    return window.Android.getAppKey();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            //渠道ID
            channel: (function () {
                if (system === 1) {
                    return window.Android.getChannel();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            // 厂商
            maker: (function () {
                if (system === 1) {
                    return window.Android.getMaker();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            // 手机类型
            mobile_model: (function () {
                if (system === 1) {
                    return window.Android.getMobileModel();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            // 手机设备号
            machine_code: (function () {
                if (system === 1) {
                    return window.Android.getMachineCode();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            // 设备ID
            machine_id: (function () {
                if (system === 1) {
                    return window.Android.getAndroidId();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            // 系统版本
            system_version: (function () {
                if (system === 1) {
                    return window.Android.getVersionName();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),
            //跳外部链接
            openUrl: (function (url) {
                if (system === 1) {
                    return window.Android.openUrl(url);
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            }),

            //获取账号
            getAccount: (function () {
                if (system === 1) {
                    return window.Android.getAccount();
                } else if (system === 2) {
                    return '';
                    // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
                }
            })(),

        };
    } else if (system === 5) { // 网页
        config = {
            host: apihost,
            key: '14e1b600b1fd579f47433b88e8d85291',
            system: system,
        };
    }

    var util = {
        // 对象转url
        jointUrl: function (data) {
            var params = '';
            for (var key in data) {
                params += key + '=' + data[key] + '&';
            }
            params = params.replace(/&{1}$/, '');
            return params;
        },
        // 获取签名
        getSign: function (options, key) {
            key = key || config.key;
            return md5(util.jointUrl(options) + key).toLowerCase();
        },
        // 深拷贝(遍历)
        deepClone: function (source) {
            const targetObj = source.constructor === Array ? [] : {};
            for (let keys in source) {
                if (source.hasOwnProperty(keys)) {
                    if (source[keys] && typeof source[keys] === 'object') {
                        targetObj[keys] = source[keys].constructor === Array ? [] : {};
                        targetObj[keys] = util.deepClone(source[keys]);
                    } else {
                        targetObj[keys] = source[keys];
                    }
                }
            }
            return targetObj;
        },
        // 跳转下载页面
        toDownloadApp: function () {
            console.log('跳转下载APP页面');

            var time = setTimeout(()=>{
                clearTimeout(time);
                window.localStorage.setItem('isJumpDownloadApp', 'true');
                let url = "http://wxt.haowusong.com/api/download/page?page_id=34&r=56";
                let key = '';
                if(runChannel(2)){ // 是否是ios
                    key = 'ios_promotion_url'
                }else{
                    key = 'promotion_url'
                }
                if(store.getters.tabbarConfig.game_menu ){
                    let promotion_url = store.getters.tabbarConfig.game_menu[key]
                    promotion_url &&(url = promotion_url)
                }
                window.parent && (window.parent.location.href = url)
            },0)
        },
        // 封装本地存储
        localStorage: {
            get: function (name) {
                return JSON.parse(localStorage.getItem(name))
            },
            set: function (name, val) {
                localStorage.setItem(name, JSON.stringify(val))
            },
            add: function (name, addVal) {
                let oldVal = util.localStorage.get(name)
                let newVal = oldVal.concat(addVal)
                util.localStorage.set(name, newVal)
            }
        },
        // 封装 sessionStorage
        sessionStorage: {
            get: function (name) {
                return JSON.parse(sessionStorage.getItem(name))
            },
            set: function (name, val) {
                sessionStorage.setItem(name, JSON.stringify(val))
            },
            add: function (name, addVal) {
                let oldVal = util.sessionStorage.get(name)
                let newVal = oldVal.concat(addVal)
                util.sessionStorage.set(name, newVal)
            }
        },
        //
        iosCookie: {
            set: function (name, value) {
                if (system === 2) {
                    window.webkit.messageHandlers.wz_callOC.postMessage({
                        method: 'iOSSetData',
                        param: {
                            key: name,
                            value: value
                        }
                    });
                }
            },
        },
        cookie: {
            set: function (name, value, expires, domain, path, secure) {
                var cookieText = "";
                cookieText += encodeURIComponent(name) + "=" + encodeURIComponent(value);
                if (expires instanceof Date) {
                    cookieText += "; expires=" + expires.toGMTString();
                }
                if (path) {
                    cookieText += "; path=" + path;
                }
                if (domain) {
                    cookieText += "; domain=" + domain;
                }
                if (secure) {
                    cookieText += "; secure";
                }
                document.cookie = cookieText;
            },
            // name=value; expires=expiration_time; path=domain_path; domain=domain_name; secure
            // 获取cookie
            get: function (name) {
                var cookieName = encodeURIComponent(name) + "=",
                    cookieStart = document.cookie.indexOf(cookieName),
                    cookieValue = "";
                if (cookieStart > -1) {
                    var cookieEnd = document.cookie.indexOf(";", cookieStart);
                    if (cookieEnd == -1) {
                        cookieEnd = document.cookie.length;
                    }
                    cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
                }
                return cookieValue;
            },
            // 删除cookie
            unset: function (name, domain, path, secure) {
                this.set(name, "", Date(0), domain, path, secure);
            }
        }
    };


    return {
        config: config,
        util: util,
        boxChannelList: boxChannelList,
    }
})();

export default Api;



// WEBPACK FOOTER //
// ./src/static/js/api.js